// extracted by mini-css-extract-plugin
export default {"header":"static-React-HVJS-HVUI-LoggedOutHeader-___LoggedOutHeader-module__header","logo":"static-React-HVJS-HVUI-LoggedOutHeader-___LoggedOutHeader-module__logo"};